import { apiService } from '@/api/apiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export type ValidateAuthTotpPayload = {
  user_id: string;
  token: string;
  token_type: string;
};

export const validateAuthTotpApi = async (
  data: ValidateAuthTotpPayload
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = '/users/totp/';

  return apiService.POST(uri, data);
};
